import { render } from "./QRCode.vue?vue&type=template&id=2a1b0bba&ts=true"
import script from "./QRCode.vue?vue&type=script&lang=ts"
export * from "./QRCode.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__